/**
 * Persist the customer's preferred branch after first signup.
 */

import { supabase } from '../config/supabase'
import { DEMO_PROFILE, isDemoMode } from '../utils/demoMode'

const DEMO_PREFERRED_SALON_KEY = 'tts_demo_preferred_salon_id'

export async function savePreferredSalon(salonId) {
  if (!salonId) {
    return { success: false, error: 'Please select a branch.' }
  }

  // Demo: keep selection local — no Supabase auth / profile write
  if (isDemoMode()) {
    try {
      sessionStorage.setItem(DEMO_PREFERRED_SALON_KEY, String(salonId))
    } catch (_) {
      // ignore storage failures
    }
    return {
      success: true,
      profile: { ...DEMO_PROFILE, preferred_salon_id: salonId },
    }
  }

  try {
    const { data: { user } } = await supabase.auth.getUser()
    if (!user) {
      return { success: false, error: 'Please sign in to continue.' }
    }

    const { data, error } = await supabase
      .from('profiles')
      .update({
        preferred_salon_id: salonId,
        updated_at: new Date().toISOString(),
      })
      .eq('id', user.id)
      .select('*')
      .maybeSingle()

    if (error) {
      return { success: false, error: error.message || 'Could not save branch.' }
    }

    return { success: true, profile: data }
  } catch (error) {
    return { success: false, error: error?.message || 'Could not save branch.' }
  }
}

export async function fetchPreferredSalonId(userId) {
  if (isDemoMode()) {
    try {
      return sessionStorage.getItem(DEMO_PREFERRED_SALON_KEY) || null
    } catch {
      return null
    }
  }
  if (!userId) return null
  try {
    const { data, error } = await supabase
      .from('profiles')
      .select('preferred_salon_id')
      .eq('id', userId)
      .maybeSingle()
    if (error) return null
    return data?.preferred_salon_id || null
  } catch {
    return null
  }
}
